export default __webpack_public_path__ + "static/media/demo_4.b18d6146.jpg";